module.exports = __webpack_public_path__ + "static/media/logo_FULL.44227c30.svg";